import { Back, TweenMax } from 'gsap';
import { Container } from 'pixi.js';
import { PlayerAvatar } from '../Shared/PlayerAvatar';

export class PlayerAvatarFrame extends Container {
    private readonly avatar: PlayerAvatar;
    private readonly frame: PIXI.Sprite;

    constructor(url: string, isPlayer: boolean) {
        super();
        const frameTexture = isPlayer ? 'mapui/avatarframe-player' : 'mapui/avatarframe-friend';
        const frame = (this.frame = new PIXI.Sprite(PIXI.utils.TextureCache[frameTexture]));
        frame.anchor.set(0.5);
        this.avatar = new PlayerAvatar(url, this.frame.width * 0.6, this.frame.height * 0.8);

        this.addChild(this.avatar, this.frame);
        if (isPlayer) {
            this.idleAnimation();
        }
    }

    public destroyAvatar() {
        TweenMax.killTweensOf(this);
        this.avatar.destroy();
        this.destroy();
    }

    public showActive(): Promise<void> {
        return new Promise(resolve => {
            TweenMax.to(this, 0.3, {
                x: this.x - this.width * 0.2,
                ease: Back.easeOut,
                yoyo: true,
                repeat: 2,
                onComplete: () => resolve(),
            });
        });
    }

    private idleAnimation() {
        if (this.parent !== null) {
            TweenMax.to(this.scale, 0.1, {
                delay: 2,
                ease: Back.easeOut.config(0.1),
                onComplete: () => {
                    this.idleAnimation2();
                },
                x: 0.9,
                y: 1,
            });
        }
    }

    private idleAnimation2() {
        if (this.parent !== null) {
            TweenMax.to(this.scale, 0.1, {
                ease: Back.easeOut.config(0.1),
                onComplete: () => {
                    this.idleAnimation3();
                },
                x: 1.1,
                y: 1.1,
            });
        }
    }

    private idleAnimation3() {
        if (this.parent !== null) {
            TweenMax.to(this.scale, 0.1, {
                ease: Back.easeOut.config(0.1),
                onComplete: () => {
                    this.idleAnimation4();
                },
                x: 1.1,
                y: 0.95,
            });
        }
    }

    private idleAnimation4() {
        if (this.parent !== null) {
            TweenMax.to(this.scale, 0.2, {
                ease: Back.easeOut.config(0.1),
                onComplete: () => {
                    if (this) {
                        this.idleAnimation();
                    }
                },
                x: 1,
                y: 1,
            });
        }
    }
}
